import { Registration } from 'app/features/manual-input-registration/models';
import { ProductBox } from 'app/shared/components/product-box/models';
import { Activity } from 'app/shared/features/activity-selector/models';

export function getRowRegistrationMessage(row: (string | undefined)[]) {
    let message = '';
    for (let i = 0; i < row.length; i++) {
        if (i === 0) {
            message += `${row[i]}`;
        } else if (i === 1) {
            message += `, ${row[i]}`;
            if (row.length > 2) {
                message += ` ...`;
                break;
            }
        }
    }
    return message;
}

export function getAmountResultRegistrationMessage(
    registration: Registration,
    activity: Activity | undefined,
) {
    return `${registration.amountResult} ${activity?.registrationUnit ?? ''}`;
}

export function getProductBoxRegistrationMessage(
    registration: Registration,
    productBox: (ProductBox | undefined)[],
) {
    let message = '';
    for (let i = 0; i < productBox.length; i++) {
        if (i === 0) {
            message += `${registration.productBoxRegistrations[i].amount ?? ''} ${productBox[i]?.name}`;
        } else if (i === 1) {
            message += `, ${registration.productBoxRegistrations[i].amount} ${productBox[i]?.name}`;
            if (productBox.length > 2) {
                message += ` ...`;
                break;
            }
        }
    }
    return message;
}

export function getContainerRegistrationMessage(container: (string | undefined)[]) {
    let message = '';
    for (let i = 0; i < container.length; i++) {
        if (i === 0) {
            message += `${container[i]}`;
        } else if (i === 1) {
            message += `, ${container[i]}`;
            if (container.length > 2) {
                message += ` ...`;
                break;
            }
        }
    }
    return message;
}

export function getLabourRegistrationMessage(
    registration: Registration,
    activity: Activity | undefined,
    productBox: (ProductBox | undefined)[],
    row: (string | undefined)[],
    container: (string | undefined)[],
    locationName: string | undefined,
    batchName: string | undefined,
) {
    let toasterLocationDetails = '';
    let toasterMessageDetails = '';

    // Set message for location based on selected location types
    if (registration.locationRegistrations) {
        toasterLocationDetails = `${locationName}`;
    } else if (row) {
        toasterLocationDetails = getRowRegistrationMessage(row);
    }

    // Set message for additional information based on selected result determination types
    // byAmount
    if (registration.amountResult) {
        toasterMessageDetails = getAmountResultRegistrationMessage(registration, activity);
    } // byContainerAndProductBox
    else if (registration.productBoxRegistrations.length > 0 && productBox && container.length > 0) {
        toasterMessageDetails =
            getContainerRegistrationMessage(container) +
            '<br/>' +
            getProductBoxRegistrationMessage(registration, productBox);
    } // byAmountAndProductBox
    else if (registration.productBoxRegistrations.length > 0 && productBox) {
        toasterMessageDetails = getProductBoxRegistrationMessage(registration, productBox);
    } // byContainer, byOneContainer
    else if (container) {
        toasterMessageDetails = getContainerRegistrationMessage(container);
    }
    return `${activity?.name}<br/>${batchName ? batchName + '<br/>' : ''}${
        toasterLocationDetails ? toasterLocationDetails + '<br/>' : ''
    }${toasterMessageDetails}`;
}

export enum AppMode {
    MultiUser = 'multi-user',
    Personal = 'personal',
}
